<template>
  <div>
    <v-dialog
      v-model="existingQantas"
      scrollable
      persistent
      :overlay="false"
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card>
        <v-title>{{ title }}</v-title>
        <v-flex xs12>
          <customer-table
            v-if="customerData"
            :customerData="customerData"
            :orderType="3"
            @existingOrder="existingOrder"
            @emptyCustomerData="closeServices()"
            @cancelOrder="$emit('closed')"
            :loading="loading"
          ></customer-table>
          <v-flex v-else>You have no eligible customers.</v-flex>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="light-grey" @click="$emit('closed')">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import customerTable from "@/components/customerTable";
export default {
  name: "QantasListCustomers",
  props: {
    existingQantas: { type: Boolean, required: true }
  },
  data() {
    return {
      customerData: [],
      loading: false,
      title: "Customers with QBR Plans"
    };
  },
  components: {
    customerTable
  },
  methods: {
    ...mapActions("orders/qantas", ["listCustomers", "existingQBRCustomers"]),
    getEligible() {
      let vm = this;
      vm.loading = true;
      vm.title = "Customers Eligible for QBR Plans";
      Object.assign(vm.customerData, []);
      vm.listCustomers(false)
        .then(data => {
          vm.customerData = data;
          vm.loading = false;
        })
        .catch(err => {});
    },
    getExisting() {
      let vm = this;
      vm.loading = true;
      vm.title = "Customers with QBR Plans";
      Object.assign(vm.customerData, []);
      vm.existingQBRCustomers()
        .then(data => {
          vm.customerData = data;
          vm.loading = false;
        })
        .catch(err => {});
    },
    existingOrder(orderID) {
      let vm = this;
      //vm.dialog = false;
      vm.retrieved = true;
      vm.loading = true;
      // vm.setResidential(true);
      this.getOrder(orderID)
        .then(order => {
          if (order) {
            if (vm.message.httpStatus === 200) {
              vm.setResidential(
                order.customerDetails
                  ? order.customerDetails.companyID == 0
                  : false
              );
              vm.loading = false;

              // if (order.orderStatus > 0)
              //   vm.$router.push({
              //     path: "order-summary"
              //   });
            }
          }
        })
        .catch(err => {
          vm.setMessage(
            new httpError({
              message: "Unable to get order: " + err.message,
              httpStatus: 500
            })
          );
        });
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
